import { Temporal } from "@js-temporal/polyfill";
import { CoreData } from "src/app/tools/core-data/core-data";

export class BaseComponent {
    public ALL = 666; // For combo list non domain date only for display

    constructor(protected coreData: CoreData) { }

    get IsDispatch() {
        return this.coreData.RoleAndPermissions.some(x => x.Name === 'CanPlanIntervention');
    }

    convertTemporalToDate(tDate: Temporal.PlainDateTime) {
        return new Date(
            tDate.year,
            tDate.month - 1,
            tDate.day,
            tDate.hour,
            tDate.minute);
    }
}